// ===============================
// Sticky ATC behavior controller
// ===============================

const bottomATC = document.querySelector('.bottom-atc');
const mainATC = document.querySelector('.product-action .addToCartBtn');

let passedMainATC = false;

// --- Observe main ATC visibility ---
const observer = new IntersectionObserver(
  ([entry]) => {
    // If main ATC is visible, force hide sticky
    if (entry.isIntersecting) {
      bottomATC.classList.remove('show');
      bottomATC.classList.add('hide');
    }
  },
  { threshold: 0 }
);

observer.observe(mainATC);

// --- Scroll position detection ---
window.addEventListener('scroll', () => {
  const currentScrollY = window.scrollY;

  // Calculate absolute position of the main button bottom
  const mainATCBottom =
    mainATC.getBoundingClientRect().bottom + window.scrollY;

  // Check if we have scrolled past the main button
  passedMainATC = currentScrollY > mainATCBottom;

  // --- Visibility rules ---
  // If we are past the main button, show the sticky one.
  if (passedMainATC) {
    bottomATC.classList.add('show');
    bottomATC.classList.remove('hide');
  } else {
    bottomATC.classList.remove('show');
    bottomATC.classList.add('hide');
  }
});